export function getValueBetweenMinMax(value: number | null | undefined, min: number, max: number): number | null {
  if (value === undefined || value === null) {
    return null;
  }

  return Math.max(min, Math.min(max, value));
}
